import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../services/api";


export const fetchInit = createAsyncThunk("data/fetchInit", async (payload, thunkAPI) => {
  try {

    const guid = payload?.guid || null;
    const sessionId = payload?.sessionId || null;

    const res = await apiClient.get("/init", { params: { guid, sessionId } });
    return res.data;
  } catch (error) {
    if (!error.errorPayload) return; // canceled / aborted
    return thunkAPI.rejectWithValue(error.errorPayload);
  }
});


export const processData = createAsyncThunk("data/processData", async (payload, thunkAPI) => {
  try {

    const { getState } = thunkAPI;
    
    const { currentQuestion, created, lastUpdated, sessionId, guid } = getState().data;
    const {answer, choices, isSkipped } = payload;

    const apiPayload = {
          question: currentQuestion,
          sessionId: sessionId,
          created: created,
          lastUpdated: lastUpdated,
          guid: guid,
          isSkipped: isSkipped,
          answer: isSkipped ? '' : answer,
          choices: isSkipped ? [] : choices,
          
    };

    const res = await apiClient.post("/process", apiPayload);
    
    return res.data;
  } catch (error) {
    if (!error.errorPayload) return; // canceled / aborted
    return thunkAPI.rejectWithValue(error.errorPayload);
  }
});

export const fetchResults = createAsyncThunk("data/fetchResults", async (payload, thunkAPI) => {
  try {

    const { getState, signal } = thunkAPI;
    const {attemptedQuestions, created, lastUpdated, sessionId, guid } = getState().data;

    const apiPayload = { created, lastUpdated, sessionId, questions: attemptedQuestions, guid };


    const res = await apiClient.post("/results", apiPayload, { signal });
    return res.data;
  } catch (error) {
    if (!error.errorPayload) return thunkAPI.rejectWithValue("Request canceled"); // canceled / aborted
    return thunkAPI.rejectWithValue(error.errorPayload);
  }
}, {
  condition: (_, { getState }) => {
    const { data } = getState();
    if (data.freezeScreen) {
      return false;
    }
  }
});


export const fetchResultsV2 = createAsyncThunk("data/fetchResultsV2", async (payload, thunkAPI) => {
  try {

    const { dispatch, getState, signal } = thunkAPI;
    const {attemptedQuestions, created, lastUpdated, sessionId, guid } = getState().data;

    const apiPayload = { created, lastUpdated, sessionId, questions: attemptedQuestions, guid };

    const res = await apiClient.post("/results2", apiPayload, { signal });
    const onetCodes = res?.data?.category.flatMap(cat => cat.data.map(item => item.onetCode) );

    dispatch(fetchProfessions(onetCodes));

    return { ...res.data, onetCodes:onetCodes};

  } catch (error) {
    if (!error.errorPayload) return thunkAPI.rejectWithValue("Request canceled"); // canceled / aborted
    return thunkAPI.rejectWithValue(error.errorPayload);
  }
});

export const fetchProfessions = createAsyncThunk("data/fetchProfessions", async (payload, thunkAPI) => {
  try {
    
    const { getState, signal } = thunkAPI;
    const { created, lastUpdated, sessionId, guid } = getState().data;

    const apiPayload = { created, lastUpdated, sessionId, guid, onetCodes: payload };

    const res = await apiClient.post("/prof-details", apiPayload, { signal });

    return res.data;
  } catch (error) {
    if (!error.errorPayload) return thunkAPI.rejectWithValue("Request canceled"); // canceled / aborted
    return thunkAPI.rejectWithValue(error.errorPayload);
  }
});

export const fetchNextQuestion = createAsyncThunk("data/fetchNextQuestion", async (_, thunkAPI) => {
  try {

    const { getState } = thunkAPI;
    const { order, guid, sessionId } = getState().data;

    const res = await apiClient.get("/next-question", { params: { currentOrder: order, guid, sessionId } });
    return res.data;
  } catch (error) {
    if (!error.errorPayload) return; // canceled / aborted
    return thunkAPI.rejectWithValue(error.errorPayload);
  }
});

export const recordProfessionClick = createAsyncThunk("data/recordProfessionClick", async (payload, thunkAPI) => {
    try {
      const { getState, signal } = thunkAPI;
      const { sessionId, guid } = getState().data;

    await apiClient.post("/record",{
      sessionId,
      guid,
      eventType:3,
      eventData: payload
    },
      { signal }
    );
    return true;
  } catch (error) {
    if (!error.errorPayload) return; // canceled / aborted
    return thunkAPI.rejectWithValue(error.errorPayload);
  }
});


export const verifyCaptcha = createAsyncThunk("data/verifyCaptcha", async (payload, thunkAPI) => {
    try {
      const { signal } = thunkAPI;

    let c = await apiClient.post("/verify",{
      captcha_token: payload
    },
      { signal }
    );
    return c.data;
  } catch (error) {
    if (!error.errorPayload) return; // canceled / aborted
    return thunkAPI.rejectWithValue(error.errorPayload);
  }
});



const initialState = {
  initAPI: { status: "idle", error: null },
  processAPI: { status: "idle", error: null },
  professionAPI: { status: "idle", error: null },
  resultsAPI: { status: "idle", error: null },
  newQuestionAPI: { status: "idle", error: null },
  moreQuestions: false,
  recommendations: {},
  order: 0,
  currentQuestion: {},
  attemptedQuestions: [],
  showCareerModal: false,
  isQuestionPoupVisible: false,
  careerData: null,
  currentPage: null,
  isQuestionEdit: false,
  onetCodes:[],
  professionList:[],
  guid: null,
  sessionId: null,
  created: null,
  lastUpdated: null,
  choiceSource:[],
  yearRange:[1,12],
  salaryRange:[22, 250],
  freezeScreen: false
};



const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    resetState: () => initialState,
    submitQuestion(state, action) {
      console.log(action.payload, "inside submit question payload");
    },
    toggleCareerModal(state, action) {
      state.showCareerModal = action.payload
    },
    showQuestionById(state, action) {
      state.isQuestionPoupVisible = true;
      state.currentQuestion = action.payload;
      state.isQuestionEdit = true;
    },
    toggleQuestionPopup(state, action) {
      state.isQuestionPoupVisible = action.payload;
      if(action.payload === false){ state.isQuestionEdit = false; }
    },
    setCareerData(state, action) {
      state.careerData = {...action.payload, content: state.professionList.find(item => item.onet_code === action.payload.onetCode)};
    },
    setChoicesPoints(state, action){
      //console.log(action.payload);
      state.choiceSource = action.payload;
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInit.pending, (state) => {
        state.initAPI.status = "loading";
        state.initAPI.error = null;
      })
      .addCase(fetchInit.fulfilled, (state, action) => {
        state.initAPI.status = "succeeded";

        const { moreQuestions, question, created, lastUpdated, sessionId, guid } = action.payload;
        
        state.moreQuestions = moreQuestions;
        state.currentQuestion = question;
        state.order = state.currentQuestion.order;
        state.created = created;
        state.lastUpdated = lastUpdated;
        state.sessionId = sessionId;
        state.guid = guid;

      })
      .addCase(fetchInit.rejected, (state, action) => {
        state.initAPI.status = "failed";
        state.initAPI.error = action.payload;
      });

    builder
      .addCase(fetchNextQuestion.pending, (state) => {
        state.newQuestionAPI.status = "loading";
        state.newQuestionAPI.error = null;
      })
      .addCase(fetchNextQuestion.fulfilled, (state, action) => {
        state.newQuestionAPI.status = "succeeded";

        
        const { moreQuestions, question } = action.payload;
        
        state.moreQuestions = moreQuestions;
        state.currentQuestion = question;
        state.order = state.currentQuestion.order;

      })
      .addCase(fetchNextQuestion.rejected, (state, action) => {
        state.newQuestionAPI.status = "failed";
        state.newQuestionAPI.error = action.payload;
      });  

    builder
      .addCase(processData.pending, (state) => {
        state.processAPI.status = "loading";
        state.processAPI.error = null;
      })
      .addCase(processData.fulfilled, (state, action) => {
        state.processAPI.status = "succeeded";

        const { question, created, lastUpdated, sessionId, guid } = action.payload;

        state.created = created;
        state.lastUpdated = lastUpdated;
        state.sessionId = sessionId;
        state.guid = guid;
        state.freezeScreen = question.callHotline;

        //if(question.isSkipped){ return }

          const found = question;
          const index = state.attemptedQuestions.findIndex(q => q.questionId === found.questionId);

          if (index !== -1) {
            state.attemptedQuestions[index] = found;
          } else {
            state.attemptedQuestions.push(found);
          }
      })
      .addCase(processData.rejected, (state, action) => {
        state.processAPI.status = "failed";
        state.processAPI.error = action.payload;
      });  
      
      builder
      .addCase(fetchResults.pending, (state) => {
        state.resultsAPI.status = "loading";
        state.resultsAPI.error = null;
      })
      .addCase(fetchResults.fulfilled, (state, action) => {
        state.resultsAPI.status = "succeeded";

        const { recommendations, lower_years_of_study, lower_min_salary, upper_max_salary, upper_years_of_study } = action.payload;
        state.recommendations = recommendations;
        state.yearRange = [lower_years_of_study, upper_years_of_study];
        state.salaryRange = [lower_min_salary / 1000, upper_max_salary / 1000]

        console.log(state.yearRange, state.salaryRange);

      })
      .addCase(fetchResults.rejected, (state, action) => {
        if (action.error.name === 'AbortError' || action.payload === "Request canceled") {
          // If screen is frozen, we are stopping completely -> set idle
          if (state.freezeScreen) {
            state.resultsAPI.status = 'idle';
          }
          // If NOT frozen, it's a replacement request -> preserve loading state (do nothing)
          return;
        }

        state.resultsAPI.status = 'failed';
        state.resultsAPI.error = action.payload;
      });

      builder
      .addCase(fetchProfessions.pending, (state) => {
        state.professionAPI.status = "loading";
        state.professionAPI.error = null;
      })
      .addCase(fetchProfessions.fulfilled, (state, action) => {
        state.professionAPI.status = "succeeded";

        const { profession_details } = action.payload;
        state.professionList = profession_details;

      })
      .addCase(fetchProfessions.rejected, (state, action) => {
        if (action.payload === "Request canceled") return;
        state.professionAPI.status = "failed";
        state.professionAPI.error = action.payload; // { httpStatus, message, raw }
      });


      

      


  },
});

export const { 
  resetState,
  submitQuestion, 
  toggleCareerModal, 
  showQuestionById, 
  toggleQuestionPopup, 
  setCareerData,
  setChoicesPoints
 } = dataSlice.actions;

export default dataSlice.reducer;
